import {
  Box,
  Text,
  Link,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  List,
  ListItem,
  Image,
  Center,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useCallback } from "react";
import {
  faFilePdf,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { getMaker, logo } from "../../../components/category";
import { useRouter } from "next/router";
import BaseLayout from "../../../components/base_layout";
import Loading from "../../../components/Loading";
import Pagination from "react-js-pagination";
import Route from "../../../components/common/route";

export default function Category() {
  const router = useRouter();
  const code = router.query.code;
  const manufacturer = router.query.manufacturer;
  const [isShow, setIsShow] = useState(true);
  const [loadingShow, setLoadingShow] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const [manufacturerGroup, setManufacturerGroup] = useState([]);
  const [data, setData] = useState("");
  const [categoryInfo, setCategoryInfo] = useState([]);
  const [noneSearchShow, setNoneSearchShow] = useState(false);
  const [searchShow, setSearchShow] = useState(false);
  const [btnActive, setBtnActive] = useState("square");

  useEffect(() => {
    getData();
  }, [page]);
  const getData = async () => {
    setLoadingShow(true);
    const axios = require("axios").default;
    if (manufacturer) {
      var URL = `${process.env.SEARCH_API_URL}/search/category?ca_id=${code}&page=${page}&offset=${perPage}&manufacturer=${manufacturer}`;
    } else {
      var URL = `${process.env.SEARCH_API_URL}/search/category?ca_id=${code}&page=${page}&offset=${perPage}`;
    }
    try {
      let res = await axios.get(URL);
      if (res.data.msg == "해당 카테고리 아이템이 없습니다.") {
        setLoadingShow(false);
        setNoneSearchShow(true);
        return;
      }
      if (res.data.data) {
        setSearchShow(true);
        setCategoryInfo(res.data.data.category_info.reverse());
        setManufacturerGroup(res.data.data.category_brand);
        setTotalCount(res.data.data.total_rows);
        setData(res.data.data.items);
        setLoadingShow(false);
      }
    } catch (e) {
      setLoadingShow(false);
    }
  };

  // manufacturer 리스트 전채 보여주고 닫는 함수
  const _showAlllist = () => {
    setIsShow(!isShow);
  };

  // 현재 페이지 나타내는 함수
  const handlePageChange = (page) => {
    window.scrollTo(0, 400);
    setPage(page);
  };

  const getBtnActive = (e) => {
    setBtnActive(e.target.value);
  };

  return (
    <BaseLayout>
      <Loading loadingShow={loadingShow} />
      <Center marginTop="10px" style={{ padding: "0 3%" }}>
        <Box className={searchShow ? "" : "search-hidden"} maxWidth="100%">
          <Box className="category-container">
            <Box className="category-nav">
              <Breadcrumb fontWeight="medium" mt="1" paddingBottom="4">
                <BreadcrumbItem>
                  <BreadcrumbLink className="category-nav__list" href="/">
                    홈
                  </BreadcrumbLink>
                </BreadcrumbItem>
                {categoryInfo.length > 0
                  ? categoryInfo.map((el) => (
                      <BreadcrumbItem isCurrentPage>
                        <BreadcrumbLink className="category-nav__list">
                          <Link href={`/parts/category/${+el.id}`}>
                            {el.name}
                          </Link>
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                    ))
                  : ""}
              </Breadcrumb>
            </Box>
            <Box className="category-box">
              <List
                className={
                  "category-list " +
                  (isShow ? "overflow-hidden" : "overflow-show")
                }
              >
                {manufacturerGroup
                  ? manufacturerGroup.map((el) => (
                      <ListItem>
                        <Link
                          href={`/parts/category/${code}?manufacturer=${el.name}`}
                          className="category-list__manufacturer"
                        >
                          {el.name}
                        </Link>
                      </ListItem>
                    ))
                  : ""}
              </List>
              {manufacturerGroup.length > 20 ? (
                isShow ? (
                  <Heading onClick={_showAlllist} className="category-heading">
                    전체브랜드 보기
                  </Heading>
                ) : (
                  <Heading onClick={_showAlllist} className="category-heading">
                    닫기
                  </Heading>
                )
              ) : (
                ""
              )}
              <Box>
                <Text
                  className="category-counting"
                  display="flex"
                  marginBottom="10px"
                >
                  총{" "}
                  <Text margin="0px 5px" color="red">
                    {totalCount.toLocaleString()}
                  </Text>
                  건
                </Text>

                <Box className="category-list-btn">
                  <ul>
                    <li>
                      {btnActive === "square" ? (
                        <button
                          className="xi-apps active"
                          value="square"
                          onClick={getBtnActive}
                        ></button>
                      ) : (
                        <button
                          className="xi-apps"
                          value="square"
                          onClick={getBtnActive}
                        ></button>
                      )}
                    </li>
                    <li>
                      {btnActive === "list" ? (
                        <button
                          className="xi-list active"
                          value="list"
                          onClick={getBtnActive}
                        ></button>
                      ) : (
                        <button
                          className="xi-list"
                          value="list"
                          onClick={getBtnActive}
                        ></button>
                      )}
                    </li>
                  </ul>
                </Box>
              </Box>

              <>
                {btnActive === "list" ? (
                  //  table / list 형식
                  <Box className="category-list_container">
                    <Box className="category-list_wrap">
                      <Box className="category-list_header">
                        <Text className="category-list__title">이미지</Text>
                        <Box className="category-list__title-box">
                          <Text
                            className="category-list__title"
                            marginRight="185px"
                          >
                            재고수량
                          </Text>
                          <Text className="category-list__title">
                            Packaging
                          </Text>
                        </Box>
                      </Box>
                      <List>
                        {data
                          ? data.map((el) =>
                              el.prices.length > 0 ? (
                                <ListItem className="category-info">
                                  <Box className="category-info__box">
                                    <Box className="category-info__box-info flex-center">
                                      <Image
                                        src={
                                          el.it_img1
                                            ? el.it_img1
                                            : el.it_img2
                                            ? el.it_img2
                                            : "/images/no_img.png"
                                        }
                                        className="category-info__box-img"
                                      />
                                      <Box>
                                        <Text>
                                          [{el.it_brand}]{el.it_name}
                                        </Text>
                                        <Text>{el.it_basic}</Text>
                                      </Box>
                                    </Box>
                                    <Box className="category-info__contents">
                                      <Box className="category-info__contents-provider">
                                        <Text color="gray" paddingRight="5px">
                                          컨텐츠 제공:
                                        </Text>
                                        <Text> {getMaker(el.it_maker)}</Text>
                                      </Box>
                                      {el.it_origin === null ||
                                      el.it_origin === "null" ||
                                      el.it_origin === "" ||
                                      el.it_origin === undefined ||
                                      el.it_origin === "undefined" ? (
                                        <Link
                                          className="non-dataSheet"
                                          isExternal="true"
                                        >
                                          <Box className="datasheet flex-center">
                                            <FontAwesomeIcon
                                              className="datasheet_icon"
                                              icon={faFilePdf}
                                            />
                                            데이터시트
                                          </Box>
                                        </Link>
                                      ) : (
                                        <Link
                                          href={el.it_origin}
                                          isExternal="true"
                                        >
                                          <Box className="datasheet flex-center">
                                            <FontAwesomeIcon
                                              className="datasheet_icon"
                                              icon={faFilePdf}
                                            />
                                            데이터시트
                                          </Box>
                                        </Link>
                                      )}
                                    </Box>
                                  </Box>
                                  <List>
                                    {el.prices
                                      ? el.prices.map((price, i) => (
                                          <ListItem className="category-info_list">
                                            <Box className="category-info-list_blank"></Box>
                                            <Box className="category-info-list_item">
                                              <Text
                                                className="category-info_list__text flex-center"
                                                width={100}
                                              >
                                                {logo(price)}
                                              </Text>
                                              <Text
                                                className="category-info_list__text flex-center"
                                                width={150}
                                              >
                                                {price.qty.toLocaleString()}{" "}
                                                재고
                                              </Text>
                                              <Text
                                                className="category-info_list__text flex-center"
                                                width={150}
                                              >
                                                {price.packaging}
                                              </Text>
                                              <Box
                                                textAlign="center"
                                                width={200}
                                              >
                                                <Route
                                                  text="실시간 재고 확인하기"
                                                  classProp={
                                                    "category-info-list_item__goto flex-center"
                                                  }
                                                  href={`/search/lists?keyword=${encodeURIComponent(
                                                    el.it_name
                                                  )}`}
                                                />
                                                {i == 0 ? (
                                                  <Text className="category-info-list_item__goto__text">
                                                    <FontAwesomeIcon
                                                      icon={faExclamationCircle}
                                                    />{" "}
                                                    취소/환불 불가
                                                  </Text>
                                                ) : (
                                                  ""
                                                )}
                                              </Box>
                                            </Box>
                                          </ListItem>
                                        ))
                                      : ""}
                                  </List>
                                </ListItem>
                              ) : (
                                ""
                              )
                            )
                          : ""}
                      </List>
                    </Box>
                  </Box>
                ) : btnActive === "square" ? (
                  // grid 형식
                  <Box className="category-list_container grid">
                    <Box className="category-list_wrap">
                      {data
                        ? data.map((el) =>
                            el.prices.length > 0 ? (
                              <Box className="category-grid_product">
                                <Box className="category-grid_product_img">
                                  {" "}
                                  <Image
                                    src={
                                      el.it_img1
                                        ? el.it_img1
                                        : el.it_img2
                                        ? el.it_img2
                                        : "/images/no_img.png"
                                    }
                                  />
                                </Box>
                                <Box className="category-grid_content">
                                  <Text className="category-grid_product_name">
                                    <span> {el.it_brand}</span>
                                    <span>{el.it_name}</span>
                                    <span>{el.it_basic}</span>
                                  </Text>
                                  <Box className="category-grid_info_contents">
                                    <Box className="category-info__contents-provider">
                                      <Text color="gray" paddingRight="5px">
                                        컨텐츠 제공:
                                      </Text>
                                      <Text> {getMaker(el.it_maker)}</Text>
                                    </Box>
                                    <Link href={el.it_origin} isExternal="true">
                                      <Box className="datasheet flex-center">
                                        <FontAwesomeIcon
                                          className="datasheet_icon"
                                          icon={faFilePdf}
                                        />
                                        데이터시트
                                      </Box>
                                    </Link>
                                  </Box>
                                </Box>
                                <Box className="category-grid_stock_match">
                                  {el.prices
                                    ? el.prices.map((price, i) => (
                                        <Box className="category-grid_stock_match_box">
                                          <Box className="category-grid_stock_match_logo">
                                            {logo(price)}
                                          </Box>
                                          <Box className="category-grid_stock_match_number">
                                            <span>
                                              {price.qty.toLocaleString()} 개
                                            </span>
                                          </Box>
                                          <Box className="category-grid_stock_match_pkg">
                                            <span> {price.packaging}</span>
                                          </Box>
                                          <Route
                                            text="실시간 재고 확인하기"
                                            classProp={
                                              "category-info-list_item__goto flex-center"
                                            }
                                            href={`/search/lists?keyword=${encodeURIComponent(
                                              el.it_name
                                            )}`}
                                          />
                                          {i == 0 ? (
                                            <Text className="category-info-list_item__goto__text">
                                              <FontAwesomeIcon
                                                icon={faExclamationCircle}
                                              />{" "}
                                              취소/환불 불가
                                            </Text>
                                          ) : (
                                            ""
                                          )}
                                        </Box>
                                      ))
                                    : ""}
                                </Box>
                              </Box>
                            ) : (
                              ""
                            )
                          )
                        : ""}
                    </Box>
                  </Box>
                ) : (
                  ""
                )}
              </>

              <Pagination
                activePage={page}
                itemsCountPerPage={perPage}
                totalItemsCount={totalCount}
                pageRangeDisplayed={5}
                prevPageText={"‹"}
                nextPageText={"›"}
                onChange={handlePageChange}
              />
            </Box>
          </Box>
        </Box>
        {/* ============ 검색결과 데이터가 없을때  ============*/}
        <Box className={noneSearchShow ? "search" : "search-hidden"}>
          <Center>
            <Box className="noneSearch">
              <Image className="noneSearch-img" src="/images/warning 1.png" />
              <Text className="noneSearch-result">등록된 상품이 없습니다.</Text>
            </Box>
          </Center>
        </Box>
      </Center>
    </BaseLayout>
  );
}
